import { lazy } from 'react'

export const AppPageAsync = lazy(() => import('./AppPage'))